import {UI} from "../../../../../../stem-core/ui/UIBase";
import {DateCalendarInputInterface} from "../../base/DateCalendarInputInterface";
import {CURRENT_PICK} from "../../DateRangePickerConstants";
import {DateRangeCalendarMonthInput} from "../components/DateRangeCalendarMonthInput";
import type {StemDate} from "../../../../../../stem-core/time/Date";
import type {DateRangeValue} from "../../DateRangePickerConstants";


export class DateRangeCalendarInput extends DateCalendarInputInterface {
    setValue(value: DateRangeValue) {
        if (!this.value || (value.startDate === this.value.startDate && value.endDate === this.value.endDate
            && value.currentPick === this.value.currentPick)) {

            this.clearAnimations();
            this.referenceTime = value.currentPick === CURRENT_PICK.startDate ? value.startDate : value.endDate;

            super.setValue(value);
            return;
        }

        if (value.startDate === this.value.startDate && value.endDate !== this.value.endDate
            && value.currentPick === CURRENT_PICK.startDate) {
            this.swipe(value.startDate);
        } else if (value.startDate !== this.value.startDate && value.endDate === this.value.endDate
            && value.currentPick === CURRENT_PICK.endDate) {
            this.swipe(value.endDate);
        } else {
            this.referenceTime = value.currentPick === CURRENT_PICK.startDate ? value.startDate : value.endDate;
        }

        super.setValue(value);
    }

    renderCalendarMonthComponent(monthDate: StemDate) {
        const {minDate, maxDate} = this.options;
        return <DateRangeCalendarMonthInput initialValue={this.value} {...{minDate, maxDate, monthDate}}
                                            onChange={value => this.setAndDispatchValue(value)} />;
    }
}
